import { render, staticRenderFns } from "./previewPageJoinGift.vue?vue&type=template&id=6ea907ca&scoped=true"
import script from "./previewPageJoinGift.vue?vue&type=script&lang=js"
export * from "./previewPageJoinGift.vue?vue&type=script&lang=js"
import style0 from "./previewPageJoinGift.vue?vue&type=style&index=0&id=6ea907ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea907ca",
  null
  
)

export default component.exports